import {api, basicAuthHeaderForCredentials, handleApiError, ServiceResponse} from "../ApiClient";
import {Credentials} from "./CredientialsService";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../store/store";
import {handleLogin} from "../store/reducers/session/slice";

export type Session = {
    idToken: string
    refreshToken: string
}

export interface SessionResponse extends ServiceResponse {
    idToken?: string
    refreshToken?: string
}

export const SessionService = () => {

    const dispatch = useDispatch<AppDispatch>();

    const createSession = async (credentials: Credentials): Promise<ServiceResponse> => {
        return api.post<Session>('/api/1/session', {}, {
            withCredentials: true,
            headers: {
                Authorization: basicAuthHeaderForCredentials(credentials)
            }
        })
            .then((resp) => {
                if (resp && resp.status === 200 && resp.data.idToken) {
                    dispatch(handleLogin('Bearer ' + resp.data.idToken))
                    return {}
                }

                return {
                    error: {
                        message: 'Could not obtain session.'
                    }
                }
            })
            .catch(handleApiError)
    };

    const renewSession = async (token: string, refreshToken: string): Promise<SessionResponse> => {
        return api.put<Session>('/api/1/session', {
            idToken: token
        }, {
            withCredentials: true,
            headers: {
                Authorization: refreshToken
            }
        })
            .then((resp) => {
                if (resp && resp.status === 200 && resp.data.idToken) {
                    return {
                        idToken: `Bearer ${resp.data.idToken}`,
                        refreshToken: refreshToken
                    }
                }

                return {
                    error: {
                        message: 'Could not obtain session.'
                    }
                }
            })
            .catch(handleApiError)
    }

    return {
        createSession,
        renewSession
    }
}
